// Breakpoints for use in JavaScript.
// Keep in sync with styles/_Variables.scss.
export const BREAKPOINT_MEDIUM = 1024
